import React, { useRef } from "react";
import { Box, Card } from '@curves/ui-base';

import useEChart from "@Util/hook/useEChart";
import ChartSkeletonLoading from "@Local/Dashboard/Components/ChartSkeletonLoading";
import { tooltipFormatter, adaptPie } from "@Local/Dashboard/dashboard.util";
const COLOR_CONFIG = [{ color: "#7E2E9C" }, { color: "#94A3B8" }, { color: "#CBD5E1" }, { color: "#E2E8F0" }, { color: "#4C0073" }];
/********* 年度消費金額 *********/
const YearlyTotalSpend = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			xAxis: ["A (20K~30K)", "B (10k~20K)", "C (5K~10K)", "D (<5K)", "S (30K+)"],
			data: [55, 25, 40, 135, 110],
		},
	} = props;
	const { data = [] } = adaptPie(sourceData, COLOR_CONFIG);
	const centerValueText = 15800;
	const isLoading = data.length === 0;
	const title = "年度消費金額";
	const option = {
		title: {
			text: title,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
		},
		tooltip: {
			trigger: "item",
			formatter: tooltipFormatter,
		},
		legend: {
			bottom: 10,
			left: "center",
			textStyle: {
				fontSize: 14,
				fontWeight: 600,
				color: "#111827",
			},
		},
		graphic: [
			{
				type: "text",
				left: "center",
				top: "43%",
				style: {
					text: "平均客單",
					fill: "#94A3B8",
					fontSize: 12,
					textAlign: "center",
				},
			},
			{
				type: "text",
				left: "center",
				top: "50%",
				style: {
					text: `{value|${centerValueText}}{unit| 次}`,
					textAlign: "center",
					rich: {
						value: {
							fill: "#4C0073",
							fontSize: 20,
							fontWeight: 700,
						},
						unit: {
							fill: "#4C0073",
							fontSize: 10,
							fontWeight: 600,
						},
					},
				},
			},
		],
		series: [
			{
				type: "pie",
				radius: ["40%", "55%"],
				center: ["50%", "50%"],
				padAngle: 3,
				avoidLabelOverlap: false,
				label: { show: false },
				labelLine: { show: false },
				itemStyle: {
					borderRadius: 8,
				},
				data: data,
			},
		],
	};
	useEChart(chartDomRef, option);
	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});
export default YearlyTotalSpend;
